<template>
    <div class="container distance">
        <div class="row>">
            <div class="twelve columns">
                <h1>Kontakt</h1>
                <p>Über dieses Kontaktformular können Sie mir eine Nachricht senden, die als Email unverschlüsselt an mein Postfach gesendet wird.</p>
            </div>
        </div>

        <div class="row">
            <div class="four columns">
                <label>Absender:</label>
            </div>
            <div class="eight columns">
                <input type="text" v-model="emailFromAddr" placeholder="Ihre Email Adresse..." />
                <!-- <input type="text"
                    v-bind:value="emailFromAddr"
                    v-on:input="$emit('input', $event.target.value)"
                    placeholder="Ihre Email Adresse..."
                /> -->
            </div>
        </div>

        <div class="row">
            <div class="four columns">
                <label>Thema:</label>
            </div>
            <div class="eight columns">
                <input type="text" v-model="emailSubject" />
            </div>
        </div>

        <div class="row">
            <div class="four columns">
                <label>Beschreibung:</label>
            </div>
            <div class="eight columns">
                <textarea v-model="emailBody"></textarea>
            </div>
        </div>

        <div class="row">
            <div class="four columns">
                &nbsp;
            </div>
            <div class="eight columns">
                <button class="button-primary" @click="on_click_SendButton" v-bind:disabled="isSending === true || isValid === false">Senden</button>
                <span v-bind:class="resultClass">{{resultText}}</span>
            </div>
        </div>

        <div class="row">
            <div class="four columns">
                &nbsp;
            </div>
            <div class="eight columns">
                <b>Hinweis zum Datenschutz:</b>
                <p>
                Bitte klicken Sie nur dann auf die "Senden" Schaltfläche, wenn Sie damit einferstanden sind,
                das ihre Nachricht - einschließlich Ihrer Email Adresse - an mein Email Postfach gesendet und dort gespeichert wird.
                </p>
                <p>
                Ich habe keinen Mechanismus implementiert, der Ihre Nachricht anschließend automatisch löschen wird, d.h. Ihre Email bleibt auf unbestimmte Zeit in meinem Postfach liegen.
                </p>
                <p>
                Auf Ihre Bitte hin werde ich natürlich Ihre Nachricht, zusamen mit Ihrer Email Adresse, aus meinem Postfach löschen -
                senden Sie mir dazu bitte einfach eine entsprechende Nachricht.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageContact',
    /*
    props: {
        emailFromAddr: String
    },
    */
    data: function () {
        return {
            emailFromAddr: '',
            emailSubject: '',
            emailBody: '',
            //
            isSending: false,
            isValid: true,
            resultText: '',
            resultClass: 'result-hidden'
        }
    },
    methods: {
        // canNotSend: function () {
        //    return this.isSending === true && this.isValid === true
        // },
        on_click_SendButton: function (event) {
            // console.log(event)
            console.log(`emailFromAddr: ${this.emailFromAddr} - emailSubject: ${this.emailSubject} - emailBody: `, this.emailBody)

            // event.target.enabled
            this.isSending = true
            this.isValid = true
            this.resultText = 'Lade Daten ...'
            this.resultClass = 'result-span result-loading'

            // validate
            // $$$

            // Sanatize
            // $$$

            // encode

            // HINT: JS: https://attacomsian.com/blog/javascript-base64-encode-decode
            // HINT: JS: https://developer.mozilla.org/en-US/docs/Glossary/Base64
            // HINT: PHP: sanatize/validate email:  https://stackoverflow.com/questions/7290674/php-is-filter-sanitize-email-pointless

            let jetzt = new Date(Date.now()).toISOString()

            let emailBody = `=== KONTAKT FORMULAR CLIENT-AT: ${jetzt} UTC ===\n`
            emailBody += `=== FROM: ${this.emailFromAddr.trim()} ===\n`
            emailBody += `=== SUBJ: ${this.emailSubject.trim()} ===\n`
            emailBody += this.emailBody.trim() + '\n'
            emailBody += '=== END. ==='

            // Avoid mixture of \n and \r\n in email.
            emailBody.replace('\r\n', '\n')
                // .replace('\n\r', '\n')
                .replace('\n', '\r\n')

            let email = {
                fromAddr: btoa(this.emailFromAddr),
                message: btoa(emailBody)
            }
            let b64JsonMail = btoa(JSON.stringify(email))
            console.log('b64JsonMail:', b64JsonMail)

            // API: send email
            // $$$ TODO: IMPLEMENT THIS:
            this.webapi$anonymouseSendContactMessage(b64JsonMail)
                .then(response => {
                    // $$$ debugger
                    console.log(response)
                    if (response.ok === true) {
                        let result = response.body
                        if (result.errors.length === 0) {
                            this.isSending = false
                            this.isValid = false
                            this.resultClass = 'result-span result-ok'
                            this.resultText = 'Ihre Nachricht wurde erfolgreich gesendet.'
                        } else {
                            this.isSending = false
                            this.isValid = true
                            this.resultClass = 'result-span result-error'
                            this.resultText = 'Achtung: Ihre Nachricht konnte nicht versendet werden!' // result.errors[0]
                        }
                    } else {
                        // Network/HTTP-protocoll error.
                        console.error(new Error(`webapi HTTP failed! - status: ${response.status} - text: ${response.statusText}`))
                        this.isSending = false
                        this.isValid = true
                        this.resultClass = 'result-span result-error'
                        this.resultText = 'Netzwerk-Fehler: Ihre Nachricht konnte nicht versendet werden !!' // result.errors[0]
                    }
                })
                .catch(err => {
                    // $$$
                    console.error(err)
                    this.isSending = false
                    this.isValid = true
                    this.resultClass = 'result-span result-error'
                    this.resultText = 'Fehler: Ihre Nachricht konnte nicht versendet werden !!' // result.errors[0]
                })
        } // on_click_SendButton()
    }
}
</script>
<style scoped>
input {
    color: black;
    width: 100%;
}
textarea {
    color: black;
    width: 100%;
}

.button-primary {
    background-color: #009000; /* IE fallback */
    background-color: #009000cc;
    background: -webkit-linear-gradient(top, #66ff66cc 0%, #009900cc 59%);
    background: linear-gradient(to bottom, #66ff66cc 0%, #009900cc 59%);
    border: 1px solid #009900; /* IE fallback */
    border: 1px solid #009900cc;
    font-weight:700;
    width: 140px;
    /* height: 3em; */
    /*
    letter-spacing: .15rem;
    border-radius: 4px;
    text-transform:none;
    font-size:1.03em;
    */
}
.button-primary:hover {
    background-color: #009000;
    text-shadow: -1.5px 0.5px 0.8px darkgreen;
    border: 1px solid darkgreen;
    font-weight:700;
    width: 140px;
    /* height: 3em; */
    /* letter-spacing: .15rem; */
    /* text-transform:none; */
    /* font-size:1.03em; */
}
.button-primary:disabled {
    cursor: wait   ; /* not-allowed; */
    background-color: grey;
    background: -webkit-linear-gradient(top, grey 0%, grey 59%);
    background: linear-gradient(to bottom, grey 0%, grey 59%);
    color: #404040;
    text-shadow: 0px 0px 0px grey;
    border: 1px solid darkgrey;
    font-weight:700;
    width: 140px;
    /* height: 3em; */
    /* letter-spacing: .15rem; */
    /* text-transform:none; */
    /* font-size:1.03em; */
}

.result-hidden {
    display: none;
}
.result-span {
    display: block;
    /* color: #008000;
    background: silver; */
    border: 0;
    margin: 10px 0px 10px 1px;
    padding: 7px 7px 7px 12px;
    border-radius: 2px;
}
.result-ok {
    color: #008000;
    background: #e0ffe0;
}
.result-error {
    color: #AA0000;
    background: #ffe0e0;
}
.result-loading {
    color: #000090;
    background-color: #e0e0ff;
    padding-left: 2.65em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/PageContact.vue